import * as React from 'react';
import { Form, Input, EditModes, LookUpDropDown, DropDown, Switch } from 'library';
import { IFormData, IFormState, SystemFormDetail } from 'library/form/SystemFormDetail';

interface IDataModel extends IFormData {
    PrimaryKeyEncrypted?: string,
    LookupId?: string,
    LookupName ?: string,
    LookupValue?: string,    
    Status?: 'Pending',
    Description?: string,
    SortOrder?: number,   
    RowVersion?: string
}

export default class ApproveLookupRequestForm extends SystemFormDetail<IDataModel>{
    constructor(props: any) {
        super(props);
    }

    initial = (): IFormState<IDataModel> => {        
        return {
            formData: {
                PrimaryKeyEncrypted: (this.props.data && this.props.data.PrimaryKeyEncrypted) ? this.props.data.PrimaryKeyEncrypted : undefined,
                Status: 'Pending',  
            },
        }
    }

    load = (data: IDataModel) => {
        if (data) {           
            this.setState({
                formData: {
                    ...data,
                    PrimaryKeyEncrypted: data.PrimaryKeyEncrypted,
                    LookupId: data.LookupId,
                    LookupName: data.LookupName,
                    LookupValue: data.LookupValue,
                    Status: data.Status,   
                    Description: data.Description,
                    SortOrder: data.SortOrder,
                    RowVersion: data.RowVersion,
                }
            })
        }
    }

    render() {
        return (<>
            <Form
                label="Lookup Request"
                url={'LookupRequest'}
                onLoad={this.load}
                showReview={false}
                primaryKeyEncrypted={this.state.formData.PrimaryKeyEncrypted}
                securityObject="Top.LookupRequest"
                schema="Top" table="LookupRequest"
                onInitialize={this.initialize}
                onClear={this.initialize}
                onValidate={this.validate}
                onPrepare={this.prepare}
                onRecordUpdated={this.onRecordUpdated} >
                     
                <div className="col-md-4 col-12 mb-2">
                    <DropDown
                        id="LookupId"
                        name="LookupId"
                        label='Lookup Table'
                        dataSource={'/LookupRequest/LookupTableGet'}
                        displayField="LookupName"
                        idField="LookupId"
                        labelClass="col-12"
                        componentClass="col-12"
                        isRequired={true}
                        onChange={this.handleChange}
                        validator={this.validator}
                        disabled={this.state.formData.PrimaryKeyEncrypted ? true : false}
                        value={this.state.formData.LookupId} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="LookupName"
                        name="LookupName"
                        label='Lookup Name'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        disabled={this.state.formData.PrimaryKeyEncrypted ? true : false}
                        value={this.state.formData.LookupName}
                        validator={this.validator} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="LookupValue"
                        name="LookupValue"
                        label='Lookup Value'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        disabled={this.state.formData.PrimaryKeyEncrypted ? true : false}
                        value={this.state.formData.LookupValue}
                        validator={this.validator} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        id="Description"
                        name="Description"
                        label='Description'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        disabled={this.state.formData.PrimaryKeyEncrypted ? true : false}
                        value={this.state.formData.Description} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        id="SortOrder"
                        name="SortOrder"
                        type="number"
                        minValue="1"
                        label='Sort Order'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        disabled={this.state.formData.PrimaryKeyEncrypted ? true : false}
                        value={this.state.formData.SortOrder} />
                </div>

                {(this.props.data === undefined) ?
                    null
                    :
                    <div className="col-md-4 col-12 mb-2">
                        <LookUpDropDown
                            id="Status"
                            name="Status"
                            label='Status'
                            lookupName='/LookupRequest/LookupValue/LookupStatus'
                            labelClass="col-12"
                            componentClass="col-12"
                            isRequired={true}
                            onChange={this.handleChange}
                            validator={this.validator}
                            disabled={this.state.formData.Status === 'Approve' ? true : false}
                            value={this.state.formData.Status} />
                    </div>
                }
            </Form>           
        </>)
    }
};